import React from 'react'
import { withStyles } from '@material-ui/core'
import styles from './styles'
import { useSelector } from 'react-redux'

const HeaderTheme = ({ classes }) => {
  const course = useSelector(state => state.course.course)

  return (
    <div className={classes.headerContainer}>
      <div className={classes.headerContent}>
        <h1>{course ? course.name : ''}</h1>
      </div>
    </div>
  )
}

export default withStyles(styles)(HeaderTheme)
